import script from "./entraideView.vue?vue&type=script&setup=true&lang=js"
export * from "./entraideView.vue?vue&type=script&setup=true&lang=js"

import "./entraideView.vue?vue&type=style&index=0&id=76444182&lang=scss&scoped=true"
import "./entraideView.vue?vue&type=style&index=1&id=76444182&lang=scss"

import exportComponent from "/home/pilki/freelaix/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76444182"]])

export default __exports__